import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealth = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19.595,
			height: 19.595,
			transform: "translate(0 0)",
			fill: "none"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-33 -854)",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "translate(33.5 854.5)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#a)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M13.34,9.8A3.543,3.543,0,1,0,9.8,13.341,3.543,3.543,0,0,0,13.34,9.8",
					fill: "current"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M9.8,19.6A9.37,9.37,0,0,1,8.1,19.44l-.541-.1-.6-2.628-.057-.024L4.625,18.131l-.455-.32a9.818,9.818,0,0,1-2.387-2.386l-.32-.455,1.444-2.288-.024-.058L.254,12.031l-.1-.543A9.824,9.824,0,0,1,0,9.8V9.794A9.729,9.729,0,0,1,.155,8.106l.1-.543,2.629-.6.024-.058L1.462,4.625l.321-.455A9.839,9.839,0,0,1,4.17,1.784l.454-.32L6.91,2.9l.058-.024L7.563.253l.543-.1A9.829,9.829,0,0,1,9.792,0H9.8a9.824,9.824,0,0,1,1.686.156l.542.1.6,2.629.057.024,2.284-1.44.454.319a9.8,9.8,0,0,1,2.388,2.385l.32.455L16.689,6.909l.024.056,2.626.59.1.541a9.288,9.288,0,0,1,0,3.394l-.1.539-2.626.6-.024.058,1.439,2.284-.32.455a9.818,9.818,0,0,1-2.387,2.386l-.455.32-2.284-1.442-.057.024-.594,2.628-.541.1A9.358,9.358,0,0,1,9.8,19.6Zm-.856-1.716a7.686,7.686,0,0,0,1.71,0L11.2,15.45l.443-.15a5.8,5.8,0,0,0,.729-.3l.421-.21L14.9,16.116A8.139,8.139,0,0,0,16.114,14.9L14.786,12.8l.21-.42a5.808,5.808,0,0,0,.305-.729l.15-.442,2.428-.553a7.609,7.609,0,0,0,0-1.715l-2.424-.545-.151-.44A5.872,5.872,0,0,0,15,7.222L14.785,6.8l1.332-2.108A8.119,8.119,0,0,0,14.9,3.48L12.795,4.81,12.374,4.6a5.778,5.778,0,0,0-.728-.3l-.441-.15-.553-2.427A8.126,8.126,0,0,0,9.8,1.667a8.138,8.138,0,0,0-.856.051L8.392,4.143l-.444.149a5.584,5.584,0,0,0-.725.3l-.42.211L4.693,3.478A8.161,8.161,0,0,0,3.478,4.692L4.812,6.8,4.6,7.222a5.6,5.6,0,0,0-.3.726l-.15.442-2.426.551a8,8,0,0,0-.05.855,8.2,8.2,0,0,0,.05.856l2.426.548.15.443a5.668,5.668,0,0,0,.305.727l.212.421L3.478,14.9a8.14,8.14,0,0,0,1.214,1.213L6.8,14.786l.421.21a5.8,5.8,0,0,0,.729.3l.442.15Z",
					fill: "current"
				})]
			})
		}), /* @__PURE__ */ _jsx("g", {
			transform: "translate(33 853.5)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5,25.5H4.5A4.505,4.505,0,0,1,0,21V18a.5.5,0,0,1,1,0v3a3.5,3.5,0,0,0,3.5,3.5h16A3.5,3.5,0,0,0,24,21V5a3.5,3.5,0,0,0-3.5-3.5.5.5,0,0,1,0-1A4.505,4.505,0,0,1,25,5V21A4.505,4.505,0,0,1,20.5,25.5Z",
				fill: "current"
			})
		})]
	})]
});
export { SvgHealth as ReactComponent };
